import type { Variants } from 'framer-motion'
import { stagger } from 'framer-motion'

import { theme } from 'styles/theme'

export const headerVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { delayChildren: stagger(0.4) } },
}

export const titleVariants: Variants = {
  animate: { transition: { delayChildren: stagger(0.3) } },
}

export const titlePartVariants: Variants = {
  initial: { opacity: 0, translateX: '-100%' },
  animate: {
    opacity: 1,
    translateX: '0%',
    transition: { type: 'tween', duration: 0.6, ease: theme.ease.out },
  },
}

export const introVariants: Variants = {
  initial: { opacity: 0, translateY: '5rem' },
  animate: {
    opacity: 1,
    translateY: '0rem',
    transition: { type: 'tween', duration: 0.7, ease: theme.ease.out },
  },
}

export const coumpoundImageVariants: Variants = {
  animate: { transition: { delayChildren: stagger(0.2) } },
}

export const slideRightVariants: Variants = {
  initial: { opacity: 0, translateX: '-100%' },
  animate: {
    opacity: 1,
    translateX: '0%',
    transition: { type: 'tween', duration: 0.5, ease: theme.ease.out },
  },
}

export const zoomVariants = (): Variants => ({
  initial: {
    opacity: 0,
    scale: 0.8,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: { type: 'tween', duration: 0.6, ease: theme.ease.out },
  },
})

export const slideTopVariants: Variants = {
  initial: { opacity: 0, translateY: '-100%' },
  animate: {
    opacity: 1,
    translateY: '0%',
    transition: { type: 'tween', duration: 0.7, ease: theme.ease.out },
  },
}
